import API from './base';

const version = 'v1';
const review = '/review';

export default {

  getMainReviews(payload) {
    return API.get(`${version}${review}/main/${payload}`);
  },

  getBonusPoints() {
    return API.get(`${version}${review}/bonus-points`);
  },

  leaveReview(payload) {
    return API.post(`${version}${review}`, payload);
  },
};
